const GCSE_PRACTICE_REPLIT_URL = 'https://memrise-gcse-practice.replit.app';

export const isReplitUrl = (url: string | undefined): boolean => {
  if (!url) return false;
  try {
    const urlObj = new URL(url, window.location.origin);
    return urlObj.origin === GCSE_PRACTICE_REPLIT_URL;
  } catch {
    return false;
  }
};
